import React from 'react'
import Box from '@mui/material/Box';
import { Container, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';

/**
 * すべての応募画面に表示するフッター
 */
export function Footer() {
    return(
        <>
            <Box
                component="footer"
                borderTop={1}
                borderColor="grey.300"
                sx={{
                    mt: "auto",
                    backgroundColor:"white",
                    borderTopColor:"primary"
                }}
            >
                <Container maxWidth="xl" disableGutters>
                    <Grid2 container>
                        <Grid2>
                            <Typography variant="body1" textAlign="left">
                                Copyright(C)<br/>
                                Photo town HIGASHIKAWA All Rights Reserved.
                            </Typography>
                        </Grid2>
                        <Box sx={{flexGrow: 1}}></Box>
                        <Grid2>
                            <Typography variant="body1" textAlign="right">
                                Version 3.0
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Container>          
            </Box>
        </>
    );
}